$(function(){
    //pc sp common
    //addclass container
    $('.container.row.center-block').addClass('pr_cont-lettertxt');
    setTimeout(function(){
        $('.container.row.center-block').addClass('pr_contfixed-trans');
    },500);
    //cart btn
    if($('.pr_cart-amounttxt').length) {
        var carttxt = $('.pr_cart-amounttxt').text().match(/\d/g).join(''),
            cartlength = carttxt.length,
            cartl = cartlength * 8;
        if (carttxt >= 1) {
            $('.pr_cart-amounttxt').parent().addClass('pr_cart-in');
        }
    }
    //if(cartlength >= 1){
    //    $('.pr_hsearch-area,.pr_login-hnav,.pr_online-contactbox').css('right','+='+cartl);
    //}
    //header drawer menu
    var btn  = $('.pr_drawer-btn'),
        menu = $('.pr_navbar .navbar-collapse');
    $(window).on('load resize',function(){
        navh = menu.outerWidth();
        $('.navbar-toggle.pr_navbar-on').css({'left':navh+15});
        if(menu.hasClass('pr_navbar-on')){
            menu.animate({'left':0});
        }else{
            menu.removeClass('pr_navbar-on').css({'left':-navh});
        }
    });
    function btnmove() {
        $('.navbar-toggle.pr_drawer-btn').animate({'left':'5px'});
    }
    function clonebox() {
        $('.pr_navclone-box').animate({'background-color': 'transparent'});
        setTimeout(function(){
            $('.pr_navclone-box').remove();
        },500);
    }
    btn.click(function(){
        $(this).toggleClass('pr_navbar-on');
        if(menu.hasClass('pr_navbar-on')){
            menu.removeClass('pr_navbar-on').animate({'left':-navh});
            btnmove();
            clonebox();
            $('.pr_cart-nav').css('z-index','505');/*fr追記*/
        }else{
            menu.addClass('pr_navbar-on').animate({'left':0});
            $('.navbar-toggle.pr_navbar-on').animate({'left':navh+15});
            $('.pr_container-h').append('<div class="pr_navclone-box"></div>');
            $('.pr_navclone-box').delay(450).animate({'background-color': '#9a9a9a'});
            $('.pr_cart-nav').css('z-index','350');/*fr追記*/
        }
    });
    $(document).on('click touchend','.pr_navclone-box' ,function(){
        clonebox();
        btnmove();
        menu.removeClass('pr_navbar-on').animate({'left':-navh});
        btn.removeClass('pr_navbar-on');
        $('.pr_cart-nav').css('z-index','505');/*fr追記*/
    });

    //divide
    $(window).load(function(){
        var winw = $(window).outerWidth();
        if(winw > 767) {
            //header
            var hh = $('.pr_hnav-area').outerHeight();
            $('.pr_hnav-area').parent().css('padding-top', hh);

            //slide down menu
            var slideb = $('.pr_slided-menubox'),
                slidebtn = $('.pr_slided-menubtn'),
                slidem = $('.pr_slided-menu');
            slidem.css('display', 'none');
            var slidebh = $('.pr_slided-menubox').outerHeight();
            slidem.css({
                'position': 'absolute',
                'left': 0,
                'top': slidebh,
                'width': '100%',
                'height': 'auto',
                'padding': '25px 20px 15px',
                'background-color': 'rgba(245,244,240,1)',
                'border-bottom': '1px solid #a59b67'
            });

            //header search
            var ser = $('.pr_hsearch-area'),
                seropen = 'pr_hsearch-open';
            $('.pr_gnav-btnarea').css('opacity', 1);
            ser.click(function () {
                if ($(this).is(':animated')) {
                    return false;
                }
                if ($(this).hasClass(seropen)) {
                    $(this).removeClass(seropen).animate({'width': 70}, 800).find('.pr_input-group input').blur();
                } else {
                    $(this).animate({'width': 200}, 800).addClass(seropen);
                }
            });

            if(!$('.js_fr_hsearch').length) {
                $(document).on('click touchend', function (e) {
                    if (!$.contains($('.pr_hsearch-area')[0], e.target) && ser.hasClass(seropen)) {
                        ser.removeClass(seropen).animate({'width': 70}, 800).find('.pr_input-group input').blur();
                    }
                });
            }

            //footer
            $('.pr_hnav-area').css('position','fixed');
            setTimeout(function(){
                var fh   = $('.pr_footer-area').outerHeight();
                var winh = $(window).outerHeight();
                //$('.pr_footer-area').css({'height':fh,'position':'absolute'}).parent().css({'position':'relative','min-height':winh,'padding-bottom':fh});
                $('.pr_footer-area').css({'height':fh}).parent().css({'position':'relative','padding-bottom':fh,'height':'100%'});
            },500);
        }else{
            //header
            $('.pr_navbar-h .navbar-toggle').click(function(){
                $('.pr_slided-menubox').slideUp();
            });
            //footer drop down
            var dropmemu = $('.pr_drop-menu');
            var dropbtn = $('.pr_drop-btn');
            dropbtn.click(function(){
                $(this).toggleClass('pr_drop-btn-on');
                $(this).next().toggleClass('pr_drop-menu-open').slideToggle();
            });
            //drop down
            var menubtn = $('.pr_menudown-btn'),
                menuinfo = $('.pr_menudown-info');
            menuinfo.css('display','none');
            menubtn.click(function(){
                $(this).toggleClass('pr_menudown-btn-on');
                $(this).next().slideToggle();
            });
        }
        if(window.matchMedia('(min-width: 992px)').matches){
            $('.pr_slided-menubtn,.pr_slided-menu').hover(function(){
                    $('.pr_slided-menubtn').parent().removeClass('pr_gnav-open').find(slidem).fadeOut();
                    $(this).parent().addClass('pr_gnav-open').find(slidem).stop(true,false).fadeIn();
                },function(){
                    $('.pr_gnav li').removeClass('pr_gnav-open');
                    $('.pr_gnav li .pr_slided-menu').fadeOut('fast');
            });
        }else{
            $('.pr_slided-menubtn').click(function () {
                var comslidec = 'pr_gnav-open';
                if ($(this).hasClass(comslidec)) {
                    $('.pr_slided-menubtn').removeClass(comslidec).next(slidem).fadeOut();
                } else {
                    $('.pr_slided-menubtn').removeClass(comslidec).next(slidem).fadeOut();
                    $(this).addClass(comslidec).next(slidem).stop(true, false).fadeIn();
                }
            });
        }
    });
});